import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M42.832 43.73L15.576 50.75a3.604 3.604 0 01-4.384-2.589L2.949 16.15a3.604 3.604 0 012.589-4.384l25.357-6.53 6.49 2.906 8.036 31.204a3.604 3.604 0 01-2.589 4.384z"
        fill="#F2F2F2"
      />
      <Path
        d="M5.796 12.77a2.566 2.566 0 00-1.843 3.122l8.243 32.01a2.566 2.566 0 003.122 1.843l27.256-7.018a2.567 2.567 0 001.843-3.122l-7.91-30.721-5.705-2.554-25.006 6.44z"
        fill="#fff"
      />
      <Path
        d="M37.316 8.307l-4.218 1.086a1.199 1.199 0 01-1.46-.862l-.803-3.115a.076.076 0 01.024-.076.075.075 0 01.08-.012l6.389 2.838a.075.075 0 01-.012.141z"
        fill="#F2F2F2"
      />
      <Path
        d="M35.097 35.643l-12.41 3.196a.6.6 0 11-.299-1.162l12.41-3.195a.6.6 0 01.299 1.16zM37.996 36.986l-14.804 3.812a.6.6 0 11-.299-1.161l14.804-3.813a.6.6 0 01.3 1.162z"
        fill="#CCC"
      />
      <Path
        d="M33.778 30.098L17.297 34.34a1.857 1.857 0 01-2.259-1.334L11.584 19.59a1.857 1.857 0 011.334-2.258L29.4 13.09a1.857 1.857 0 012.258 1.333l3.454 13.417a1.857 1.857 0 01-1.333 2.259z"
        fill="#fff"
      />
      <Path
        d="M33.778 30.098L17.297 34.34a1.857 1.857 0 01-2.259-1.334L11.584 19.59a1.857 1.857 0 011.334-2.258L29.4 13.09a1.857 1.857 0 012.258 1.333l3.454 13.417a1.857 1.857 0 01-1.333 2.259zM12.973 17.542a1.638 1.638 0 00-1.177 1.993l3.454 13.417a1.639 1.639 0 001.992 1.177l16.481-4.242a1.639 1.639 0 001.177-1.993l-3.454-13.417a1.639 1.639 0 00-1.993-1.177l-16.48 4.242z"
        fill="#E6E6E6"
      />
      <Path
        d="M28.563 17.6l-8.318 2.141a.298.298 0 01-.36-.187.286.286 0 01.201-.365l8.467-2.18c.342.174.252.529.01.591zM28.939 19.059L20.62 21.2a.298.298 0 01-.361-.188.287.287 0 01.202-.364l8.467-2.18c.342.174.252.529.01.59z"
        fill="#F2F2F2"
      />
      <Path
        d="M19.037 22.494l-2.539.653a.324.324 0 01-.393-.232l-.771-2.996a.323.323 0 01.232-.393l2.539-.653a.323.323 0 01.393.232l.77 2.996a.324.324 0 01-.232.393z"
        fill="#E6E6E6"
      />
      <Path
        d="M29.683 22.053L16.99 25.32a.298.298 0 01-.36-.187.286.286 0 01.201-.364l12.844-3.307c.342.174.252.528.01.59zM30.059 23.512l-12.695 3.267a.298.298 0 01-.36-.187.288.288 0 01.202-.364l12.843-3.306c.342.173.252.527.01.59zM30.434 24.97L17.74 28.238a.298.298 0 01-.36-.187.286.286 0 01.201-.365l12.844-3.306c.342.173.252.528.01.59zM30.81 26.43l-12.694 3.267a.298.298 0 01-.361-.187.286.286 0 01.202-.365L30.8 25.84c.342.174.252.528.01.59zM31.186 27.888L18.49 31.156a.298.298 0 01-.36-.188.287.287 0 01.201-.364l12.844-3.306c.342.173.252.528.01.59z"
        fill="#F2F2F2"
      />
      <Circle cx={18.5} cy={40.5} r={3.5} fill="#F2F2F2" />
      <Path
        d="M53.563 54.764H25.418a3.604 3.604 0 01-3.6-3.6V18.109a3.604 3.604 0 013.6-3.6h26.185l5.56 4.432v32.223a3.604 3.604 0 01-3.6 3.6z"
        fill="#E6E6E6"
      />
      <Path
        d="M25.473 15.545a2.567 2.567 0 00-2.564 2.564v33.055a2.566 2.566 0 002.564 2.563h28.145a2.567 2.567 0 002.564-2.563V19.44l-4.887-3.896H25.473z"
        fill="#fff"
      />
      <Path
        d="M57.055 19.084H52.7a1.199 1.199 0 01-1.199-1.2v-3.216a.075.075 0 01.083-.075.075.075 0 01.039.016l5.48 4.341a.076.076 0 01.024.084.075.075 0 01-.07.05zM32.618 24.873c0-.241.195-.437.436-.437h2.4c.241 0 .437.196.437.437v2.945a.436.436 0 01-.437.436h-2.4a.436.436 0 01-.436-.436v-2.945z"
        fill="#CCC"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.672 22.145H31.418c-1.024 0-1.855.83-1.855 1.855v13.2c0 1.024.83 1.854 1.855 1.854h16.254c1.025 0 1.855-.83 1.855-1.854V24c0-1.024-.83-1.855-1.855-1.855zm-16.254-.327A2.182 2.182 0 0029.236 24v13.2c0 1.205.977 2.181 2.182 2.181h16.254a2.182 2.182 0 002.182-2.181V24a2.182 2.182 0 00-2.182-2.182H31.418z"
        fill="#CCC"
      />
      <Path
        d="M37.2 25.527c0-.18.146-.327.327-.327h8.4a.327.327 0 110 .654h-8.4a.327.327 0 01-.327-.327zM32.618 30.218c0-.18.146-.327.327-.327h12.982a.327.327 0 110 .654H32.945a.327.327 0 01-.327-.327zM32.618 31.745c0-.18.146-.327.327-.327h12.982a.327.327 0 110 .655H32.945a.327.327 0 01-.327-.328zM32.618 33.273c0-.181.146-.328.327-.328h12.982a.327.327 0 110 .655H32.945a.327.327 0 01-.327-.327zM37.2 27.163c0-.18.146-.327.327-.327h5.127a.327.327 0 010 .655h-5.127a.327.327 0 01-.327-.328z"
        fill="#CCC"
      />
      <Circle cx={29.5} cy={45.5} r={3.5} fill="#CCC" />
      <Path
        d="M34.91 44.545c0-.3.244-.545.545-.545h13.09a.545.545 0 010 1.09h-13.09a.545.545 0 01-.546-.545zM34.909 46.618c0-.301.244-.546.545-.546h15.71a.545.545 0 010 1.091h-15.71a.545.545 0 01-.545-.545z"
        fill="#CCC"
      />
      <Circle cx={51} cy={48.5} r={7.5} fill="#316ABE" />
      <Path
        d="M53.014 45.772l2.136.07-1.007-1.885-1.007-1.886-.82 1.319a4.55 4.55 0 00-5.692 1.757l1.07.666a3.288 3.288 0 013.947-1.338l-.763 1.227 2.136.07zM56.354 49.858a4.514 4.514 0 00-.346-3.46l-1.111.595c.414.773.503 1.661.25 2.5a3.26 3.26 0 01-1.057 1.589l-.683-1.274-1.126 1.817-1.126 1.817 2.136.067 2.137.066-.734-1.367a4.51 4.51 0 001.66-2.35zM48.221 51.579a3.26 3.26 0 01-.822-1.721l1.443.065-.984-1.897-.984-1.898-1.151 1.801-1.151 1.801 1.55.07a4.51 4.51 0 001.169 2.63 4.514 4.514 0 003.15 1.474l.056-1.26a3.262 3.262 0 01-2.276-1.065z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
